import React from "react";
import { MusicHallAndPracticeThankContainerStyled } from "./styled";
import { withRouter } from "navigations/withRouter";
import { withTranslation } from "react-i18next";
import queryString from "query-string";
import { ROUTE_PATH } from "utils/constants/routePath";
import { Buttons, Navigations } from "components";

class MusicHallAndPracticeThankContainer extends React.Component {
  handleBack = () => {
    const { router } = this.props;
    const roomId = queryString.parse(router.location.search)?.room_id;
    // replace เพื่อไม่ให้กด back ของ browser ย้อนกลับมาหน้าขอบคุณได้อีก
    if (roomId && /^[0-9a-f]{24}$/i.test(roomId)) {
      router.navigate(`${ROUTE_PATH.MUSIC_HALL_AND_PRACTICE}/${roomId}`, {
        replace: true,
      });
    } else {
      router.navigate(`${ROUTE_PATH.HOME}`, { replace: true });
    }
  };

  render() {
    const { t, router, i18n } = this.props;
    const locationSplit = router.location.pathname.split("/");
    const isNoMember = !locationSplit.some((e) => e === "system");
    const DATE_BREADCRUMB = [
      {
        name: t("Home", { ns: "common" }),
        path: ROUTE_PATH.HOME,
      },
    ];
    return (
      <MusicHallAndPracticeThankContainerStyled>
        {!isNoMember && (
          <div className="breadcrumb_layout">
            <Navigations.Breadcrumb data={DATE_BREADCRUMB} />
          </div>
        )}
        <div className="music_hall_and_practice_thank_container">
          <div className="thank_label">
            {i18n.language === "en"
              ? "Thank you for joining our event.\nWe will send a confirmation email to the address you provided in the form."
              : "ขอบคุณที่เข้าร่วมกิจกรรม\nเราจะส่งอีเมลยืนยันไปยังที่อยู่อีเมลที่ท่านได้ให้ไว้ในแบบฟอร์ม"}
          </div>
          {!isNoMember && (
            <div className="btn_back_layout">
              <Buttons.BgStandard
                height="48px"
                label={t("Back", { ns: "common" })}
                onClick={this.handleBack}
              />
            </div>
          )}
        </div>
      </MusicHallAndPracticeThankContainerStyled>
    );
  }
}

// export default withRouter(MusicHallAndPracticeThankContainer);
export default withTranslation(["common"])(
  withRouter(MusicHallAndPracticeThankContainer),
);
